import { Icon } from '@iconify/react';
import { BarChart, UnfoldLess, UnfoldMore } from '@mui/icons-material';
import { Box, Card, IconButton, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useStyles } from 'src/careflow/helpers/workflowStyle';
import uuidv4 from 'src/utils/uuidv4';
import { statisticsCard } from '../helpers/util';

interface Props {
  workflowTitle: string;
  statisticsData: any;
  path: string;
  namespace: string;
  i18n: any;
}

export function WorkflowStatistics({
  workflowTitle,
  statisticsData,
  path,
  namespace,
  i18n,
}: Props) {
  const classes = useStyles({});

  const [showStatistics, setShowStatistics] = useState(false);
  const [showStatisticsDetail, setShowStatisticsDetail] = useState(false);

  const data = Object.entries(statisticsData ?? {})
    .filter(([_, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => {
      const conf = statisticsCard[key];
      if (!conf) return null;
      return {
        title: i18n(`${path}.statistics.${key}`, namespace) || '',
        value,
        color: conf.color,
        icon: (
          <Icon icon={conf.icon} className={classes.iconShapeBox} style={{ color: conf.color }} />
        ),
      };
    })
    .filter(Boolean);

  return (
    <Card sx={{ mb: 1, boxShadow: 'none' }}>
      <Stack sx={{ m: 2 }} direction="row" spacing={1} alignItems="center">
        <Typography sx={{ ml: 2, fontWeight: 'bold' }}>{workflowTitle}</Typography>
        {workflowTitle !== '' && statisticsData && (
          <IconButton onClick={() => setShowStatistics(!showStatistics)}>
            <BarChart sx={{ color: '#5119b7' }} />
          </IconButton>
        )}
      </Stack>
      {showStatistics && (
        <Card sx={{ margin: 2, backgroundColor: '#f4f6f8' }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography sx={{ my: 2, ml: 2, fontWeight: 'bold' }}>
              {i18n(`${path}.statistics.title`, namespace)}
            </Typography>
            <IconButton onClick={() => setShowStatisticsDetail(!showStatisticsDetail)}>
              {showStatisticsDetail ? <UnfoldLess /> : <UnfoldMore />}
            </IconButton>
          </Stack>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(5, 1fr)',
              mx: 2,
              mb: 2,
              gap: 1.5,
            }}
          >
            {data?.map((item) => (
              <CardStatistics
                key={uuidv4()}
                title={item?.title}
                value={item?.value}
                icon={item?.icon}
                color={item?.color}
                classes={classes.shapeBox}
              />
            ))}
          </Box>
        </Card>
      )}
    </Card>
  );
}

export const CardStatistics = ({ title, value, icon, color, classes }: any) => (
  <Card
    variant="outlined"
    sx={{
      cursor: 'pointer',
      paddingRight: '20px',
      boxShadow: 'none',
      overflow: 'hidden',
    }}
  >
    <Stack
      sx={{
        width: '100%',
        alignItems: 'stretch',
        p: '16px 8px',
      }}
    >
      <Typography variant="h4">{value}</Typography>
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          width: '100%',
        }}
      >
        {title}
      </Typography>
      {icon}
      <Box className={classes} sx={{ background: color }} />
    </Stack>
  </Card>
);
